import { smoothScroll } from './modules/_smoothScroll.js';
import { aos } from './modules/_aos.js';
import { design } from './modules/_design.js';
import { header } from './modules/_header.js';
import { video } from './modules/_video.js';
import { kvSlideshow } from './modules/_kvSlideshow.js';

document.addEventListener('DOMContentLoaded', () => {
  smoothScroll();
  aos();
  design();
  header();
  video();
  kvSlideshow();
});
